<div class="error container">
  <div class="error__content">
    <dgx-components-icon size="xl" name="circle-exclamation">
    </dgx-components-icon>
    <h1>Something went wrong</h1>
    <p>
      Sorry, there's a problem with our website. To place your order, please
      call us or start an online chat.
    </p>

    <ng-container *ngIf="currentPlan?.plan_number">
      <p class="plan-text">Your plan number is:</p>
      <p dgxQmSanitise="encrypt">
        {{ currentPlan?.plan_number }}
      </p>
    </ng-container>

    <p class="live-chat">
      Live chat is available Monday to Friday 8am-6pm, <br />
      and Saturday 8.30am-4.30pm.
    </p>

    <dgx-components-button
      [disabled]="!isLiveChatActive"
      (clicked)="openLiveChat()"
    >
      Start chat
    </dgx-components-button>

    <section class="call-us">
      <p>Or call us on:</p>

      <section>
        <dgx-components-icon name="phone"> </dgx-components-icon>
        <a href="tel:03330004970"> 0333 000 4970 </a>
      </section>

      <p class="call-cost">
        Calls cost the basic rate per minute plus your phone company’s access
        charge. <br />
        From a mobile, they can cost much more.
      </p>
    </section>

    <p class="error-code">Error code: {{ msg }}</p>
  </div>
</div>
